// Import React modules
import React from "react";
// Import CSS stylesheets
import "../styles/variables.css";
import "../styles/layoutStyles.css";

interface TopBarProps {
  onAvatarClick: () => void;
  userInitials: string;
  userEmail: string;
  isLeftTabCollapsed: boolean;
  toggleLeftTab: () => void;
}

function TopBar({
  onAvatarClick,
  userInitials,
  userEmail,
  isLeftTabCollapsed,
  toggleLeftTab,
}: TopBarProps) {
  return (
    <div className="box-sizing-default top-bar-container">
      <div style={{ display: "flex", height: "100%", width: "100%", alignItems: "center" }}>
        <div
          className={`hamburger-menu ${isLeftTabCollapsed ? "" : "rotate"}`}
          onClick={toggleLeftTab}
        >
          <span>☰</span>
        </div>
        <div className="box-sizing-default images" id="home-logo-image"></div>
      </div>

      {userInitials ? (
        <div
          className="box-sizing-default top-bar-avatar"
          onClick={onAvatarClick}
        >
          <div className="box-sizing-default top-bar-avatar-initials">
            {userInitials}
          </div>
        </div>
      ) : (
        userEmail && (
          <button
            className="box-sizing-default top-bar-email"
            onClick={onAvatarClick}
          >
            {userEmail}
          </button>
        )
      )}
    </div>
  );
}

export default TopBar;
